export default __webpack_public_path__ + "static/proposal-5fc432ace89f28b946d55af3c326a18a.jpg";